import { v4 as uuidv4 } from "uuid";

export default function todosReducer(currentTodos, action) {
    // ADE DATE FUNCTION
    function getCurrentDateTime() {
        let date = new Date();

        function formatTwoDigits(number) {
            return number < 10 ? '0' + number : number;
        }

        let day = formatTwoDigits(date.getDate());
        let month = formatTwoDigits(date.getMonth() + 1);
        let year = date.getFullYear();
        let hours = formatTwoDigits(date.getHours());
        let minutes = formatTwoDigits(date.getMinutes());

        return `${year}/${month}/${day} || ${hours}:${minutes}`;
    }
    // ==== ADE DATE FUNCTION ====
    switch (action.type) {
        case 'added': {
            let newTodo = {
                id: uuidv4(),
                title: action.payload.title,
                details: "",
                isCompleted: false,
                createdAt: getCurrentDateTime()
            };
            const updatedTodos = [...currentTodos, newTodo]
            localStorage.setItem("todos", JSON.stringify(updatedTodos))
            return updatedTodos
        }

        case 'deleted': {
            let newTodos = currentTodos.filter((item) => {
                return item.id !== action.payload.id
            })
            localStorage.setItem("todos", JSON.stringify(newTodos))
            return newTodos
        }

        case 'updated': {
            const updatedTodos = currentTodos.map((item) => {
                if (item.id === action.payload.id) {
                    return (
                        {
                            ...item,
                            title: action.payload.title,
                            details: action.payload.details
                        }
                    )
                } else return item
            })
            localStorage.setItem("todos", JSON.stringify(updatedTodos))
            return updatedTodos
        }

        case 'showed': {
            const storageTodos = JSON.parse(localStorage.getItem("todos"))
            return storageTodos
        }

        case 'completed': {
            const updatedTodos = currentTodos.map((item) => {
                if (item.id == action.payload.id) {
                    const updatedTodo = {
                        ...item, isCompleted: !item.isCompleted
                    }
                    return updatedTodo
                }
                return item
            })
            localStorage.setItem("todos", JSON.stringify(updatedTodos))
            return updatedTodos
        }

        default: {
            throw Error("not khnown type: ", action.type)
        }
    }

}